import { AuthService as auth } from "../Services/AuthService";
import { ApiService as api } from "../Services/APIService";
import { TemplateService } from "../Services/TemplateService";
import { UtilService as util } from "../Services/UtilService";
import { LangService } from "../Services/LangService";
import Quill from 'quill';
const Delta = Quill.import('delta');

// Constants
// ComponentName
const componentName = 'prayerwall';

// Templates
const template = 'PrayerWall';
const templateAnsweredPrayer = 'PrayerWallAnsweredPrayer';
const templateAdmin = 'PrayerWallAdmin';
const templateFlagModal = 'PrayerWallFlagModal';
const templateCreateModal = 'PrayerWallCreateModal';
const templateAdminPrayerModal = 'PrayerWallAdminPrayerModal';
const templateMyPrayer = 'PrayerWallMyPrayer';
const templateMyListPrayer = 'PrayerWallMyListPrayer';
const templateEditMyModal = 'PrayerWallEditMyModal';
const templateWelcomeModal = 'PrayerWallWelcomeModal';
const templateLoadMore = 'PrayerWallLoadMore';
const templateVerses = 'PrayerWallVerses';

// Cookies
const popupCookieName = 'PrayerWallWelcome';

/// DB Constant Values
const engagementPrayer = 1;
const engagementEncourage = 2;
const engagementList = 4;
const engagemnetUpdate = 5;
const engagementFlag = 6;
const engagementFlagClear = 7;

/// Element Variables
var CongregationId = "5";
var AuthObj = null;

export class PrayerWallModule {
    // *********************************************************
    // Main INIT Methods
    // *********************************************************
    static async Init() {
        DEBUG && console.log('PrayerWall Constructor Fired...');

        var elements = document.querySelectorAll('[data-component="prayerWall"]');

        elements.forEach(element => {
            const lang = element.getAttribute('data-lang');
            const congregationId = element.getAttribute('data-congregationId');
            this.CongregationId = congregationId;

            DEBUG && console.info('**************************************************');
            DEBUG && console.info(`Element ID:              ${element.id}`);
            DEBUG && console.info(`Congregation ID:         ${congregationId}`);
            DEBUG && console.info(`Language:                ${lang}`);
            DEBUG && console.info('**************************************************');

            // Get User Auth Obj
            auth.getAuthentication()
                .then(authObj => {
                    if (authObj) {
                        this.AuthObj = authObj;
                        this.InitPrayerWall(element, authObj, congregationId, lang);
                    }
                    else {
                        // Show Login Required
                        util.showLoginRequired(element, lang);
                    }                    
                });            
        });
    }

    static async InitPrayerWall(element, authObj, congregationId, defaultLanguage) {
        DEBUG && console.log('PrayerWall Initializing...');
        var prayerDataItems = await this.getPrayerWallData(0, false, false, false, false, defaultLanguage);

        let self = this;

        var dataObj = {};
        dataObj.PrayerRequests = prayerDataItems;
        dataObj.authObj = authObj;
        dataObj.langData = await LangService.load(componentName, defaultLanguage);

        console.log(dataObj);

        // Load Primary Group Leader Template
        var mainContent = await TemplateService.GetRenderedTemplate(template, dataObj);
        element.innerHTML = mainContent;

        // Add Event Listeners
        await this.addPrayerWallEvents(element, congregationId);

        // Check for Welcome Cookie
        // If NOT - Show Welcome Message / Set Cookie
        if (!util.getCookie(popupCookieName)) {

            // Set Cookie
            util.setCookie(popupCookieName, '1', 3650);

            await self.openGuidelinesModal(defaultLanguage);
        }

        // Wire up btnGuidelines
        var btnGuidelines = document.getElementById("btnGuidelines");

        btnGuidelines.addEventListener('click', function () {
            self.openGuidelinesModal();
        });

        // Wire up Load More Button
        let btnLoadMorePrayer = document.getElementById("btnLoadMorePrayer");
        btnLoadMorePrayer.addEventListener('click', function () {
            self.loadMorePrayerRequests();
        });
    };

    // *********************************************************
    // GET Data Methods
    // *********************************************************
    static async getPrayerWallData(skip, myPrayerOnly = false, answeredPrayers = false, adminMode = false, myPrayerListOnly=false, defaultLanguage) {
        try {
            const lang = LangService.getCurrentLanguage(defaultLanguage);
            const data = await api.getApiDataAsync(`Prayer/GetPrayerRequests?skip=${skip}&myPrayerOnly=${myPrayerOnly}&answeredPrayers=${answeredPrayers}&adminMode=${adminMode}&myPrayerListOnly=${myPrayerListOnly}&lang=${lang}`, true);
            DEBUG && console.info(data);
            return data;
        } catch (error) {
            console.error("Error fetching prayer wall data:", error);
            throw error; // Rethrow if you want the caller to handle the error
        }
    }

    static async getPrayerData(id, adminMode = false) {
        const lang = LangService.getCurrentLanguage(null);
        var data = await api.getApiDataAsync(`Prayer/GetPrayerRequest/${id}?adminMode=${adminMode}&lang=${lang}`, true);
        DEBUG && console.info(data);
        return data;
    }

    static async getPrayerOutcomes() {
        var data = await api.getApiDataAsync(`Prayer/GetPrayerOutcomes`, true);
        DEBUG && console.info(data);
        return data;
    }

    static async getPrayerWallAdminData() {
        try {
            const data = await api.getApiDataAsync(`Prayer/GetAdminData`, true);
            DEBUG && console.info(data);
            return data;
        } catch (error) {
            console.error("Error fetching prayer wall admin data:", error);
            throw error; // Rethrow if you want the caller to handle the error
        }
    }

    static async getSuggestedVerses(prayerId, encouragement, btnSuggestVerse, quillEditor, lang) {
        console.log('Requesting Verses for encouragement::');
        var containerVerse = document.getElementById('containerVerse');

        var payload = {};
        payload.Prayer_Request_ID = `${prayerId}`;
        payload.Encouragement = encouragement;        
        payload.Language = lang;

        // Post the Data to the API
        try {
            var results = await api.postApiDataAsync('Prayer/SuggestVerses', payload, null, false, false, true);     

            if (results.response) {
                // convert to object
                const versesObject = JSON.parse(results.response);
                versesObject.langData = await LangService.load(componentName, null);
                console.log(versesObject);

                // Put Results into container
                // Load Primary Group Leader Template
                var mainContent = await TemplateService.GetRenderedTemplate(templateVerses, versesObject);
                containerVerse.innerHTML = mainContent;

                // Hide Button Now that complete
                btnSuggestVerse.style.display = 'none';


                // Select all buttons with the class 'btnSuggestedVerse'
                const buttons = document.querySelectorAll('.btnSuggestedVerse');

                // Iterate over each button and attach a click event listener
                buttons.forEach(function (button) {
                    button.addEventListener('click', function (event) {
                        // Find the closest parent container with the class 'suggestedVerseContainer'
                        const container = button.closest('.suggestedVerseContainer');
                        if (container) {
                            // Within this container, find the element with the class 'suggestedVerse'
                            const verseElement = container.querySelector('.suggestedVerse');
                            if (verseElement) {
                                // Get the text content of the suggested verse and trim any extra whitespace
                                const verseText = verseElement.textContent.trim();

                                // Insert the Verse Text into the end of the QuillJS
                                const currentLength = quillEditor.getLength();

                                // Insert the verse text at the end of the editor
                                quillEditor.clipboard.dangerouslyPasteHTML(currentLength, `<p>${verseText}</p><br>`);


                            } else {
                                console.warn('No element with class "suggestedVerse" found within the container.');
                            }
                        } else {
                            console.warn('No parent with class "suggestedVerseContainer" found.');
                        }
                    });
                });
                
            }

        } catch (error) {
            util.showErrorToast('An error occurred while processing your request', 8000, true);
            console.error(error);
        }

    }
    
    // *********************************************************
    // CREATE Data Methods
    // *********************************************************
    static async createPrayerEngagement(prayerId, type, notes) {
        DEBUG && console.log('===> PrayerWall Event || createPrayerEngagement');
        DEBUG && console.log('===> prayerId:', prayerId);
        DEBUG && console.log('===> type:    ', type);

        // Translate type to int for MP
        var typeId = 1;
        var successMessage = 'Thank you for praying!';
        if (type == 'flag') {
            typeId = engagementFlag;
            successMessage = 'Your flag has been recorded.';
        }
        if (type == 'prayerList') {
            typeId = 4;
            successMessage = 'This has been added to your prayer list.';
        }

        // Construct the payload
        var payload = {};
        payload.Prayer_Request_ID = parseInt(prayerId);
        payload.Prayer_Engagement_Type_ID = typeId;
        payload.Notes = notes;

        DEBUG && console.info(payload);

        // Post the Data to the API
        try {
            var results = await api.postApiDataAsync('Prayer/CreatePrayerEngagement', payload, null, false, false, true);
            util.showSuccessToast(successMessage, 5000, true);
            util.closeModal('baseModal');
        } catch (error) {
            util.showErrorToast('An error occurred while processing your request', 8000, true);
            console.error(error);
        }
    }

    static async removeFromMyList(prayerId) {
        // Construct the payload
        var payload = {};
        payload.Prayer_Request_ID = parseInt(prayerId);

        DEBUG && console.info(payload);

        // Post the Data to the API
        try {
            var results = await api.postApiDataAsync('Prayer/EndDatePrayerEngagement', payload, null, false, false, true);
            // Re-Init My List
            this.openMyPrayerList();
        } catch (error) {
            util.showErrorToast('An error occurred while processing your request', 8000, true);
            console.error(error);
        }
    }

    static async createPrayerRequest(formElement) {
        DEBUG && console.log('===> PrayerWall Event || createPrayerRequest');

        // Get FormData
        var formData = util.getFormDataObject(formElement);
        console.log(formData);

        // Construct the payload
        var payload = {};
        payload.Prayer_Request = formData.Prayer_Request;
        payload.Anonymous = formData.Anonymous === "on";
        payload.Congregation_ID = parseInt(formData.Congregation_ID);

        DEBUG && console.info(payload);

        // Post the Data to the API
        try {
            var results = await api.postApiDataAsync('Prayer/CreatePrayerRequest', payload, null, false, false, true);
            util.showSuccessToast('Your prayer request has been saved.', 5000, true);
            util.closeModal('baseModal');

            // Need a reload prayer requests event
            await this.Init();

        } catch (error) {
            util.showErrorToast('An error occurred while processing your request', 8000, true);
            console.error(error);
        }        
    }

    static async createEncouragment(formElement) {
        DEBUG && console.log("===> PrayerWall Event || Send Communication");

        var formData = util.getFormDataObject(formElement);

        DEBUG && console.info(formData);

        var payload = {};
        payload.Prayer_Request_ID = parseInt(formData.Prayer_Request_ID);
        payload.Encouragement_Message = formData.Encouragement_Message;
        payload.Encouragement_Subject = formData.Encouragement_Subject;
        
        DEBUG && console.info(payload);

        // Post the Data to the API
        try {
            var results = await api.postApiDataAsync('Prayer/CreateEncouragement', payload, null, false, false, true);
            util.showSuccessToast('Your message has been sent', 8000, true);

            // Update UI State of Prayer Card
            const pb = document.getElementById(`prayButton-${formData.Prayer_Request_ID}`);
            this.addPrayerToCard(pb);

            util.closeModal('baseModal');
        } catch (error) {
            util.showErrorToast('An error occurred while sending your message', 8000, true);
            console.error(error);
        }
    }

    // *********************************************************
    // UPDATE Data Methods
    // *********************************************************
    static async updateMyPrayerRequest(formElement) {
        DEBUG && console.log('===> PrayerWall Event || updateMyPrayerRequest');

        // Get FormData
        var formData = util.getFormDataObject(formElement);
        console.log(formData);

        // Construct the payload
        var payload = {};
        payload.Prayer_Request_ID = parseInt(formData.Prayer_Request_ID);
        payload.Prayer_Request = formData.Prayer_Request;
        payload.Anonymous = formData.Anonymous === "on";
        payload.Outcome = formData.Outcome;

        if (formData.Prayer_Outcome_ID == "") {
            payload.Prayer_Outcome_ID = null;
        }
        else {
            payload.Prayer_Outcome_ID = parseInt(formData.Prayer_Outcome_ID);
        }
        

        DEBUG && console.info(payload);

        // Post the Data to the API
        try {
            var results = await api.postApiDataAsync('Prayer/UpdateMyPrayer', payload, null, false, false, true);
            util.showSuccessToast('Your prayer request has been updated.', 5000, true);
            util.closeModal('baseModal');

            // Reload My Prayer
            await this.openMyPrayer();

        } catch (error) {
            util.showErrorToast('An error occurred while processing your request', 8000, true);
            console.error(error);
        }
    }

    static async updatePrayerRequest(formElement) {
        DEBUG && console.log('===> PrayerWall Event || updatePrayerRequest');

        // Get FormData
        var formData = util.getFormDataObject(formElement);
        console.log(formData);

        // Post the Data to the API
        try {
            var results = await api.postApiDataAsync('Prayer/UpdatePrayer', formData, null, false, false, true);
            util.showSuccessToast('Prayer request has been updated.', 5000, true);
            util.closeModal('baseModal');

            // Reload My Prayer
            await this.Init();

        } catch (error) {
            util.showErrorToast('An error occurred while processing your request', 8000, true);
            console.error(error);
        }
    }

    static async updatePrayerRequestForceFlag(prayerRequestId) {

        var payload = {};
        payload.Prayer_Request_ID = prayerRequestId;

        // Post the Data to the API
        try {
            var results = await api.postApiDataAsync('Prayer/ForceFlag', payload, null, false, false, true);
            util.showSuccessToast('Prayer request has been flagged.', 5000, true);
            util.closeModal('baseModal');

            // Reload Prayer Wall
            await this.Init();

        } catch (error) {
            util.showErrorToast('An error occurred while processing your request', 8000, true);
            console.error(error);
        }
    }

    static async blockPrayerRequest(prayerRequestId) {
        var payload = {};
        payload.Prayer_Request_ID = parseInt(prayerRequestId);

        // Post the Data to the API
        try {
            var results = await api.postApiDataAsync('Prayer/BlockPrayer', payload, null, false, false, true);
            util.showSuccessToast('Prayer request has been blocked.', 5000, true);

            await this.openPrayerAdmin();

        } catch (error) {
            util.showErrorToast('An error occurred while processing your request', 8000, true);
            console.error(error);
        }
    }

    // *********************************************************
    // OPEN TAB Methods
    // *********************************************************
    static async openMyPrayer() {

        const element = document.getElementById('myPrayer');

        let self = this;

        var prayerDataItems = await this.getPrayerWallData(0, true, false, false, false)

        //0, true, null, false, null)

        var dataObj = { "PrayerRequests": prayerDataItems };
        dataObj.langData = await LangService.load(componentName, null);

        console.log(dataObj);

        // Load Primary Group Leader Template
        var mainContent = await TemplateService.GetRenderedTemplate(templateMyPrayer, dataObj);
        element.innerHTML = mainContent;

        await self.addMyPrayerEvents(element, this.CongregationId);
    }

    static async openMyPrayerList() {

        const element = document.getElementById('myPrayerList');

        let self = this;

        var prayerDataItems = await this.getPrayerWallData(0, false, false, false, true);

        var dataObj = { "PrayerRequests": prayerDataItems };
        dataObj.langData = await LangService.load(componentName, null);

        console.log(dataObj);

        // Load Primary Group Leader Template
        var mainContent = await TemplateService.GetRenderedTemplate(templateMyListPrayer, dataObj);
        element.innerHTML = mainContent;

        //prayer-remove-button
        var buttons = element.querySelectorAll(".prayer-remove-list");
        buttons.forEach(item => {
            item.addEventListener('click', function () {
                const prayerId = item.getAttribute("data-id");
                self.removeFromMyList(prayerId);
            });
        });
    }

    static async openAnsweredPrayer() {

        const element = document.getElementById('prayerWallAnswered');

        let self = this;

        var prayerDataItems = await this.getPrayerWallData(0, false, true);

        var dataObj = { "PrayerRequests": prayerDataItems };
        dataObj.langData = await LangService.load(componentName, null);

        // Load Primary Group Leader Template
        var mainContent = await TemplateService.GetRenderedTemplate(templateAnsweredPrayer, dataObj);
        element.innerHTML = mainContent;
    }

    static async openPrayerAdmin() {

        // Load Chart JS
        util.loadScript('https://cdn.jsdelivr.net/npm/chart.js', function () { DEBUG && console.info('Chart JS Loaded'); });

        const element = document.getElementById('prayerWallAdmin');

        let self = this;

        var adminDataObj = await this.getPrayerWallAdminData();
        adminDataObj.langData = await LangService.load(componentName, null);

        // Load Admin with Data
        var mainContent = await TemplateService.GetRenderedTemplate(templateAdmin, adminDataObj);
        element.innerHTML = mainContent;

        //open-prayer-button
        var openButtons = element.querySelectorAll(".openPrayer-button");
        openButtons.forEach(item => {
            item.addEventListener('click', function () {
                const prayerId = item.getAttribute("data-id");
                self.openAdminPrayerModal(prayerId, baseModal, true);
            });
        });

        // Add Charts for Campus
        console.log('=====> adminData:', adminDataObj);

        this.createPieChart('prayerCampus7Day', adminDataObj.WeekNewPrayerRequests);
        this.createPieChart('prayerCampusToday', adminDataObj.NewPrayerRequests);
        this.createPieChart('prayerCampusYear', adminDataObj.YearNewPrayerRequests);
    }

    static createPieChart(elementId, dataObj) {
        const element = document.getElementById(elementId);

        const colorMapping = {
            'Melbourne': '#4E79A7',  // Soft Blue
            'Viera': '#59A14F',      // Gentle Green
            'Sebastian': '#F28E2B',  // Warm Orange
            'Espanol': '#B07AA1'     // Muted Purple
        };

        const groupedCounts = dataObj.reduce((acc, curr) => {
            const congregation = curr.Congregation_Name;
            acc[congregation] = (acc[congregation] || 0) + 1;
            return acc;
        }, {});

        const labels = Object.keys(groupedCounts);
        const data = labels.map(label => groupedCounts[label]);
        const backgroundColors = labels.map(label => colorMapping[label] || '#cccccc'); // Default gray if not found

        new Chart(element, {
            type: 'pie',
            data: {
                labels,
                datasets: [{
                    label: '# of Prayer Requests',
                    data,
                    borderWidth: 1,
                    backgroundColor: backgroundColors,
                }]
            },
            options: {
                plugins: {
                    legend: {
                        display: false
                    }
                }
            }
        });

        element.style.maxHeight = '110px';
        element.style.margin = "0 auto";
    }

    // *********************************************************
    // OPEN Modal Methods
    // *********************************************************
    static async openAddPrayerModal(baseModal, congregationId) {
        var dataObj = {};
        dataObj.congregationId = congregationId;
        dataObj.langData = await LangService.load(componentName, null);

        console.log('====> openPrayerModal');
        console.log(dataObj);

        var content = await TemplateService.GetRenderedTemplate(templateCreateModal, dataObj);
        baseModal.innerHTML = content;

        let self = this;

        // btnSubmitCreatePrayer
        let btnSubmitCreatePrayer = baseModal.querySelector('#btnSubmitCreatePrayer');
        let alertAnonymous = baseModal.querySelector('#alertAnonymous');
        let anonymousCheckbox = baseModal.querySelector('#anonymousCheckbox');

        anonymousCheckbox.addEventListener('change', function () {
            if (anonymousCheckbox.checked) {
                util.ShowElement(alertAnonymous.id);
            }
            else {
                util.HideElement(alertAnonymous.id);
            }
        });

        let formElement = document.getElementById('formPrayerCreate');

        // Open Modal
        util.openModal(baseModal.id);

        // Setup Form
        util.formSetup(formElement);

        formElement.addEventListener('submit', function (event) {

            event.preventDefault();
            event.stopPropagation();

            // Check overall form validity including textareas
            if (!formElement.checkValidity()) {
                console.info("*** => Form INVALID");
                formElement.classList.add('was-validated');
                return;
            } else {
                console.info("*** => Form Valid / Submitting");
                // Perform your form submission logic here
                self.createPrayerRequest(formElement);
            }

            formElement.classList.add('was-validated');

        }, false);
    }    

    static async openEditMyPrayer(prayerId, baseModal) {

        console.log('Opening Open Prayer Modal::', prayerId);

        var prayerData = await this.getPrayerData(prayerId);
        var prayerOutcomes = await this.getPrayerOutcomes();

        var dataObj = {};
        dataObj.prayerData = prayerData;
        dataObj.prayerOutcomes = prayerOutcomes;
        dataObj.langData = await LangService.load(componentName, null);

        console.log("Edit MY Prayer Request Data::");
        console.log(dataObj);

        let self = this;

        // Load UI into baseModal
        var content = await TemplateService.GetRenderedTemplate(templateEditMyModal, dataObj);
        baseModal.innerHTML = content;

        let formElement = document.getElementById('formEditMyPrayer');

        const prayerOutcomeSelect = baseModal.querySelector('#Prayer_Outcome_ID');
        const prayerOutcome = baseModal.querySelector('#Outcome');

        prayerOutcomeSelect.addEventListener('change', function () {
            if (prayerOutcomeSelect.value !== '') {
                prayerOutcome.disabled = false;
            }
            else {
                prayerOutcome.disabled = true;
            }
        });

        // Open Modal
        util.openModal(baseModal.id);

        // Setup Form
        util.formSetup(formElement);

        formElement.addEventListener('submit', function (event) {

            event.preventDefault();
            event.stopPropagation();

            // Check overall form validity including textareas
            if (!formElement.checkValidity()) {
                console.info("*** => Form INVALID");
                formElement.classList.add('was-validated');
                return;
            } else {
                console.info("*** => Form Valid / Submitting");
                // Perform your form submission logic here
                self.updateMyPrayerRequest(formElement);
            }

            formElement.classList.add('was-validated');

        }, false);
    }

    static async openAdminPrayerModal(prayerId, baseModal, flagMode) {

        console.log('Opening Admin Prayer Modal::', prayerId);

        // Load QuillJS Styles for Encouragment Box
        util.loadExternalCSS(`https://cdn.jsdelivr.net/npm/quill@2.0.0-rc.2/dist/quill.snow.css`);

        var prayerData = await this.getPrayerData(prayerId, true);
        var prayerOutcomes = await this.getPrayerOutcomes();

        var dataObj = {};
        dataObj.prayerData = prayerData;
        dataObj.prayerOutcomes = prayerOutcomes;
        dataObj.authObj = this.AuthObj;
        dataObj.langData = await LangService.load(componentName, null);

        if (this.AuthObj.UserGroups?.includes("Prayer Admin")) {
            dataObj.isPrayerAdmin = true;
        } 

        if (flagMode) {
            dataObj.flagMode = true;
        }

        const currentLang = LangService.getCurrentLanguage();

        console.log("Admin Edit Prayer Request Data::");
        console.log(dataObj);

        let self = this;

        // Load UI into baseModal
        var content = await TemplateService.GetRenderedTemplate(templateAdminPrayerModal, dataObj);
        baseModal.innerHTML = content;

        let formElement = document.getElementById('formAdminEditPrayer');
        let formAdminCloseElement = document.getElementById('formAdminClosePrayer');
        let formEncouragmentElement = document.getElementById('formAdminSendEncouragement');

        // Open Modal
        util.openModal(baseModal.id);

        // Setup Form
        if (formElement) {
            util.formSetup(formElement);

            formElement.addEventListener('submit', function (event) {

                event.preventDefault();
                event.stopPropagation();

                // Check overall form validity including textareas
                if (!formElement.checkValidity()) {
                    console.info("*** => Form INVALID");
                    formElement.classList.add('was-validated');
                    return;
                } else {
                    console.info("*** => Form Valid / Submitting");
                    // Perform your form submission logic here
                    self.updatePrayerRequest(formElement);
                }

                formElement.classList.add('was-validated');

            }, false);
        }



        // Setup Encouragement Form
        if (formEncouragmentElement) {
            util.formSetup(formEncouragmentElement);

            // Attempt to setup QuillJS
            let encouragementQuill = document.getElementById('Encouragement_Message_Quill');

            // Setup QuillJS
            const quill = new Quill('#Encouragement_Message_Quill', {
                theme: 'snow'
            });

            formEncouragmentElement.addEventListener('submit', function (event) {

                event.preventDefault();
                event.stopPropagation();

                var quillEditor = new Quill('#Encouragement_Message_Quill');
                var EncouragementMessage = document.getElementById('Encouragement_Message');

                EncouragementMessage.value = quillEditor.root.innerHTML;

                // Check overall form validity including textareas
                if (!formEncouragmentElement.checkValidity()) {
                    console.info("*** => Form INVALID");
                    formEncouragmentElement.classList.add('was-validated');
                    return;
                } else {
                    console.info("*** => Form Valid / Submitting");
                    // Perform your form submission logic here
                    self.createEncouragment(formEncouragmentElement);
                }

                formEncouragmentElement.classList.add('was-validated');

            }, false);

            let btnSuggestVerse = document.getElementById('btnSuggestVerse');

            btnSuggestVerse.addEventListener('click', function () {
                var quillEditor = new Quill('#Encouragement_Message_Quill');
                var message = quillEditor.root.innerHTML;

                var prayerIdEl = document.getElementById('Encouragement_Prayer_Request_ID');

                // disable button
                btnSuggestVerse.disabled = true;

                // change text to animated spinning circle
                // Change the button's content to a spinner
                btnSuggestVerse.innerHTML = '<i class="fas fa-spinner fa-spin"></i>';

                // Optionally, add a tooltip or aria-label for accessibility
                btnSuggestVerse.setAttribute('aria-label', 'Loading...');

                self.getSuggestedVerses(prayerIdEl.value, message, btnSuggestVerse, quillEditor, currentLang);
            });
        }

        // Setup Admin Close Form
        if (formAdminCloseElement) {
            util.formSetup(formAdminCloseElement);

            formAdminCloseElement.addEventListener('submit', function (event) {

                event.preventDefault();
                event.stopPropagation();

                // Check overall form validity including textareas
                if (!formAdminCloseElement.checkValidity()) {
                    console.info("*** => Form INVALID");
                    formAdminCloseElement.classList.add('was-validated');
                    return;
                } else {
                    console.info("*** => Form Valid / Submitting");
                    // Perform your form submission logic here
                    self.updatePrayerRequest(formAdminCloseElement);
                }

                formAdminCloseElement.classList.add('was-validated');

            }, false);
        }

        let btnForceFlag = document.getElementById('btnForceFlag');
        if (btnForceFlag) {
            btnForceFlag.addEventListener('click', function () {
                var prayerRequestId = btnForceFlag.getAttribute("data-id");
                //self.updatePrayerRequestForceFlag(prayerRequestId);

                // Close Modal
                // util.closeModal(baseModal.id);

                // Re-Open Modal
                self.openFlagModal(prayerRequestId, baseModal);
            });
        }

        //btnBlock
        let btnBlock = document.getElementById('btnBlock');
        if (btnBlock) {
            btnBlock.addEventListener('click', function () {
                var prayerRequestId = btnBlock.getAttribute("data-id");

                console.info("*** => Block Prayer Request");
                console.log(prayerRequestId);

                // Run Block
                self.blockPrayerRequest(prayerRequestId);
            });
        }

        let btnUpdateClear = document.getElementById('btnUpdateClear');
        if (btnUpdateClear) {
            btnUpdateClear.addEventListener('click', function () {
                let ClearFlags = document.getElementById('ClearFlags');
                if (ClearFlags) {
                    ClearFlags.value = "true";
                }

                // Click Sumbit Button
                let btnFormAdminEditSubmit = document.getElementById('btnFormAdminEditSubmit');
                if (btnFormAdminEditSubmit) {
                    btnFormAdminEditSubmit.click();
                }
            });
        }

    }

    static async openFlagModal(prayerId, baseModal) {
        console.log('Opening Flag Prayer Modal::', prayerId);

        var prayerData = await this.getPrayerData(prayerId);

        var dataObj = {};
        dataObj.prayerData = prayerData;
        dataObj.langData = await LangService.load(componentName, null);

        let self = this;

        // Load UI into baseModal
        var content = await TemplateService.GetRenderedTemplate(templateFlagModal, dataObj);
        baseModal.innerHTML = content;

        let formElement = document.getElementById('formFlagPrayer');

        // Open Modal
        util.openModal(baseModal.id);

        // Setup Form
        util.formSetup(formElement);

        formElement.addEventListener('submit', function (event) {

            event.preventDefault();
            event.stopPropagation();

            // Check overall form validity including textareas
            if (!formElement.checkValidity()) {
                console.info("*** => Form INVALID");
                formElement.classList.add('was-validated');
                return;
            } else {
                console.info("*** => Form Valid / Submitting");
                // Perform your form submission logic here
                self.createPrayerEngagement(prayerId, 'flag');

                // Close the Modal
                util.closeModal(baseModal.id);

                // Update UI to show Flag Active
                // Get Main Flag Button a element
                const fb = document.getElementById(`flagBtn-${prayerId}`);

                // Select the child <i> element
                const icon = fb.querySelector('i');

                if (icon.classList.contains('flag-active'))
                    return;

                // Toggle the 'flag-active' class on the <i> element
                icon.classList.toggle('flag-active');
            }

            formElement.classList.add('was-validated');

        }, false);
    }

    static async openGuidelinesModal(defaultLanguage) {
        var dataObj = {};
        dataObj.langData = await LangService.load(componentName, defaultLanguage);

        var popUpContent = await TemplateService.GetRenderedTemplate(templateWelcomeModal, dataObj);
        let baseModal = document.getElementById('baseModal');
        baseModal.innerHTML = popUpContent;
        // Open Modal
        util.openModal(baseModal.id);
    }

    // *********************************************************
    // Event Methods
    // *********************************************************
    static async addPrayerWallEvents(element, congregationId) {
        DEBUG && console.log('===> PrayerWall Init || addPrayerEvents');

        let self = this;

        let baseModal = document.getElementById('baseModal');

        //btnCreatePrayer
        var createButton = element.querySelector('#btnCreatePrayer');

        createButton.addEventListener('click', function () {
            self.openAddPrayerModal(baseModal, congregationId);
        });

        //open-prayer-button
        var openButtons = element.querySelectorAll(".openPrayer-button");
        openButtons.forEach(item => {
            item.addEventListener('click', function () {
                const prayerId = item.getAttribute("data-id");
                self.openAdminPrayerModal(prayerId, baseModal);
            });
        });

        //pray-button
        var prayButtons = element.querySelectorAll(".pray-button");
        prayButtons.forEach(pb => {

            pb.addEventListener('click', function () {

                if (pb.classList.contains('btn-prayed'))
                    return;

                const prayerId = pb.getAttribute("data-id");

                self.addPrayerToCard(pb);

                self.createPrayerEngagement(prayerId, 'prayed');
            });
        });

        //flag-button
        var flagButtons = element.querySelectorAll(".flag-button");
        flagButtons.forEach(fb => {
            fb.addEventListener('click', function () {
                const prayerId = fb.getAttribute("data-id");
                self.openFlagModal(prayerId, baseModal);                
            });
        });

        //prayList-button
        var prayerListButtons = element.querySelectorAll(".prayList-button");
        prayerListButtons.forEach(pb => {

            pb.addEventListener('click', function () {

                if (pb.classList.contains('btn-prayed'))
                    return;

                const prayerId = pb.getAttribute("data-id");

                self.addPrayerListToCard(pb);

                self.createPrayerEngagement(prayerId, 'prayed');
                self.createPrayerEngagement(prayerId, 'prayerList');
            });
        });

        //answeredPrayer-tab
        var answeredPrayerTab = document.getElementById('prayerWallAnswered-tab');
        answeredPrayerTab.addEventListener('click', function () {
            self.openAnsweredPrayer();
        });

        //myPrayer-tab
        var myPrayerTab = document.getElementById('myPrayer-tab');
        myPrayerTab.addEventListener('click', function () {
            self.openMyPrayer();
        });

        //myList-tab
        var myListTab = document.getElementById('myPrayerList-tab');
        myListTab.addEventListener('click', function () {
            self.openMyPrayerList();
        });

        //prayerWallAdmin-tab
        var prayerAdminTab = document.getElementById('prayerWallAdmin-tab');
        if (prayerAdminTab) {
            prayerAdminTab.addEventListener('click', function () {
                self.openPrayerAdmin();
            });
        }

        //prayerWallAdmin-tab
        var prayerWallTab = document.getElementById('prayerWall-tab');
        if (prayerWallTab) {
            prayerWallTab.addEventListener('click', function () {
                self.Init();
            });
        }

    }

    static async addMyPrayerEvents(element, congregationId) {
        DEBUG && console.log('===> MyPrayer Init || addPrayerEvents');

        let self = this;

        let baseModal = document.getElementById('baseModal');

        //btnCreatePrayer
        var createButton = element.querySelector('#btnCreatePrayer');

        createButton.addEventListener('click', function () {
            self.openAddPrayerModal(baseModal, congregationId);
        });

        //open-prayer-button
        var openButtons = element.querySelectorAll(".openPrayer-button");
        openButtons.forEach(item => {
            item.addEventListener('click', function () {
                const prayerId = item.getAttribute("data-id");
                self.openEditMyPrayer(prayerId, baseModal);
            });
        });
    }

    // *********************************************************
    // Specific Events
    // *********************************************************
    static addPrayerToCard(prayerButtonElement) {
        if (prayerButtonElement.classList.contains('btn-prayed'))
            return;

        // Remove a class
        prayerButtonElement.classList.remove('btn-outline-secondary');

        // Add a new class
        prayerButtonElement.classList.add('btn-prayed');

        prayerButtonElement.innerHTML = `<i class="fas fa-thumbs-up" aria-hidden="true"></i> I Prayed`;

        // Call API to add prayed data
        const prayerId = prayerButtonElement.getAttribute("data-id");

        // Get data-count and prayerCounter-id
        const prayerCounter = document.getElementById(`prayerCounter-${prayerId}`);
        let prayerCount = parseInt(prayerCounter.getAttribute('data-count'));

        prayerCount++;

        let prayerText = "Prayers";

        if (prayerCount == 1)
            prayerText = "Prayer"


        prayerCounter.textContent = `${prayerCount} ${prayerText}`;
    }

    static addPrayerListToCard(prayerListButtonElement) {
        if (prayerListButtonElement.classList.contains('btn-prayerList'))
            return;

        // Remove a class
        prayerListButtonElement.classList.remove('btn-outline-secondary');

        // Add a new class
        prayerListButtonElement.classList.add('btn-prayerList');

        prayerListButtonElement.innerHTML = `<i class="fas fa-clipboard-list" aria-hidden="true"></i>  My List`;

        // Call API to add prayed data
        const prayerId = prayerListButtonElement.getAttribute("data-id");

        // Call Prayer Button Update
        // Find the closest ancestor (or self) with the class `.flag-button`
        const prayerButton = document.getElementById(`prayButton-${prayerId}`);

        this.addPrayerToCard(prayerButton);
    }

    static async loadMorePrayerRequests() {
        let currentPrayerRequests = document.querySelectorAll('.prayerCard');
        let currentPrayerRequestsArray = Array.from(currentPrayerRequests);
        let currentPrayerCount = currentPrayerRequests.length;

        let baseModal = document.getElementById('baseModal');

        var newPrayerRequests = await this.getPrayerWallData(currentPrayerCount);

        // Check for more prayer requests
        if (newPrayerRequests.length < 30) {
            // hide the load more button
            util.HideElement('btnLoadMorePrayer');
        }

        // Load New Prayer Requests
        let prayerRequestContainer = document.getElementById('prayerRequestContainer');

        let self = this;

        var dataObj = { "PrayerRequests": newPrayerRequests, "authObj": this.AuthObj };
        dataObj.langData = await LangService.load(componentName, null);

        // Load Primary Group Leader Template
        var newPrayerContent = await TemplateService.GetRenderedTemplate(templateLoadMore, dataObj);

        // append new elements to prayer request container
        prayerRequestContainer.insertAdjacentHTML("beforeend", newPrayerContent);

        let allPrayerRequests = document.querySelectorAll('.prayerCard');

        allPrayerRequests.forEach(function (prayerCard) {
            if (!currentPrayerRequestsArray.includes(prayerCard)) {

                console.info(prayerCard);

                //open-prayer-button
                var openButtons = prayerCard.querySelectorAll(".openPrayer-button");
                openButtons.forEach(item => {
                    item.addEventListener('click', function () {
                        const prayerId = item.getAttribute("data-id");
                        self.openAdminPrayerModal(prayerId, baseModal);
                    });
                });

                //pray-button
                var prayButtons = prayerCard.querySelectorAll(".pray-button");
                prayButtons.forEach(pb => {

                    pb.addEventListener('click', function () {

                        if (pb.classList.contains('btn-prayed'))
                            return;

                        const prayerId = pb.getAttribute("data-id");

                        self.addPrayerToCard(pb);

                        self.createPrayerEngagement(prayerId, 'prayed');
                    });
                });

                //flag-button
                var flagButtons = prayerCard.querySelectorAll(".flag-button");
                flagButtons.forEach(fb => {
                    fb.addEventListener('click', function () {
                        const prayerId = fb.getAttribute("data-id");
                        self.openFlagModal(prayerId, baseModal);
                    });
                });

                //prayList-button
                var prayerListButtons = prayerCard.querySelectorAll(".prayList-button");
                prayerListButtons.forEach(pb => {

                    pb.addEventListener('click', function () {

                        if (pb.classList.contains('btn-prayed'))
                            return;

                        const prayerId = pb.getAttribute("data-id");

                        self.addPrayerListToCard(pb);

                        self.createPrayerEngagement(prayerId, 'prayed');
                        self.createPrayerEngagement(prayerId, 'prayerList');
                    });
                });


            }
        });
    }
}